<template>
  <footer class="footer">
    <div class="columns is-mobile">
      <div class="column">
        <h6>legal</h6>
        <ul>
          <li>
            <router-link to="/impressum">imprint</router-link>
          </li><!--
          <li>
            <router-link to="/datenschutz">Datenschutz</router-link>
          </li>
        </ul>
      </div>
      <div class="column">
        <h6>About</h6>
        <ul>
          <li>
            <router-link to="/contact">Kontakt</router-link>
          </li>-->
        </ul>
      </div>
      <div class="column" id="column-further-reading">
        <h6>further reading</h6>
        <ul>
          <li>
            <a href="https://www.instagram.com/con_pat_gtc/">
              <i class="fab fa-lg fa-instagram"></i>
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/patrick-conrad-dev">
              <i class="fab fa-lg fa-linkedin"></i>
            </a>
          </li>
          <li>
            <a href="https://www.xing.com/profile/Patrick_Conrad21">
              <i class="fab fa-lg fa-xing-square"></i>
            </a>
          </li>
          <li>
            <a href="https://github.com/conpat">
              <i class="fab fa-lg fa-github-square"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="copyright">
      Handcrafted by me
      <span class="icon">
        <i class="far fa-copyright"></i>
      </span>
      Conrad Patrick {{ copyrightYear }}.
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Footer',
  data: function () {
    return {
      copyrightYear: new Date().getFullYear()
    }
  }
}
</script>
<style lang="scss" scoped>
div#column-further-reading {
  //display: flex;
  //flex-direction: column;
}

ul {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
li {
  padding: 5px;
}
</style>